import { Headline, Icon, styled } from '@zeiss/beyond-online-react';
import { useBreakpoint } from '@zeiss/lib-helpers';

import { StyledContainer } from 'src/types';

const BenefitListItem = styled.li<StyledContainer>`
  display: flex;
  gap: ${({ $isMinTablet }) =>
    /* istanbul ignore next -- @preserve */
    $isMinTablet ? 'var(--spacing-s)' : 'var(--spacing-xs)'};
  align-items: center;

  &:not(:last-child) {
    margin-bottom: ${({ $isMinTablet }) =>
      /* istanbul ignore next -- @preserve */
      $isMinTablet ? 'var(--spacing-s)' : 'var(--spacing-xs)'};
  }

  & > svg {
    flex-shrink: 0;
    color: var(--color-list-icon-strong);
  }
`;

const StyledList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
`;

export interface BenefitListProps {
  data: string[];
}

export const BenefitList = ({ data }: BenefitListProps) => {
  const isMinTablet = useBreakpoint('tablet');

  return (
    <StyledList>
      {data.map((benefit) => (
        <BenefitListItem $isMinTablet={isMinTablet} key={benefit}>
          <Icon icon="Benefits" size={isMinTablet ? 48 : 16} />
          <Headline headline={benefit} size={isMinTablet ? 'm' : 'xs'} />
        </BenefitListItem>
      ))}
    </StyledList>
  );
};
